<template>
  <div class="content-tabs">
    <van-tabs
      v-model:active="active"
      color="#FF8831"
      background="#FFFFF"
      title-active-color="#FF8831"
      title-inactive-color="#BDBDBD"
      @click-tab="onClickTab"
      animated
      lazy-render
    >
      <van-tab
        v-for="(tab, index) in tabsArray"
        :title="tab.describe"
        :name="tab.type"
        :key="index"
      >
        <template #title>
          <div class="slot-title">
            <van-icon
              :name="tab.type == 'myContent' ? 'phone-circle-o ' : 'chat-o'"
            />
            {{ tab.describe }}
            <div v-if="tab.type == 'myContent'" class="line"></div>
          </div>
        </template>
      </van-tab>
    </van-tabs>
  </div>
  <MyComment v-if="!showMyContent" />
  <MyContent v-if="showMyContent" />
</template>

<script>
import {
  Tab,
  Tabs,
  List,
  Grid,
  GridItem,
  Cell,
  CellGroup,
  PullRefresh,
  Icon,
  Button,
  Image as VanImage,
  ImagePreview,
  Divider,
  Toast,
} from "vant";
// import useDateDiff from "@/composiables/useDateDiff.js";
import { useStore } from "vuex";
// import { useRouter } from "vue-router";
import { ref, computed } from "vue";
import MyContent from "@/components/MyContent.vue";
import MyComment from "@/components/MyComment.vue";
export default {
  name: "ContentCell",
  props: { item: Object, index: Number },
  components: {
    MyContent,
    MyComment,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [VanImage.name]: VanImage,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [PullRefresh.name]: PullRefresh,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [List.name]: List,
    [Divider.name]: Divider,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Toast.name]: Toast,
  },
  data() {
    return {
      active: "myContent",
      tabsArray: [
        {
          describe: "我的内容",
          type: "myContent",
        },
        {
          describe: "我的评论",
          type: "myComment",
        },
      ],
    };
  },
  setup() {
    // const router = useRouter();
    const store = useStore();
    // const loading = ref(false);
    // const finished = ref(false);
    // const refreshing = ref(false);

    // const setImgBind = (item, image) => {
    //   console.log(item, image);
    //   let arr = [244, 114, 96]
    //   let length = item.images.length - 1
    //   return {
    //     width: arr[length] + 'px',
    //     height: arr[length] + 'px',
    //     src: image,
    //     fit: 'cover'
    //   }
    // };

    // const like = (id, index) => {
    //   const params = {
    //     content_id: id,
    //   };
    //   store.dispatch("contentLike", { params, index });
    // };

    // const handleClick = (id) => {
    //   router.push("/detail/" + id);
    // };

    // const dealDate = (dateString) => {
    //   return useDateDiff(dateString);
    // };

    const showMyContent = ref(true);
    const onClickTab = ({ title }) => {
      // Toast(title);
      if (title == "我的内容") {
        showMyContent.value = true;
      } else {
        showMyContent.value = false;
      }
    };

    return {
      // like,
      // handleClick,
      // dealDate,
      // loading,
      // finished,
      // refreshing,
      contents: computed(() => store.state.myContentData),
      onClickTab,
      showMyContent,
      // setImgBind,
      // imageColumnNum: computed(() => {
      // console.log(store.state.contents);
      // return 1
      // })
    };
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-top: 5vw;
  padding-bottom: 90px;
  --van-pull-refresh-head-text-color: white;
}

.content-list {
  --van-list-text-color: #5190d5;
}
.group-top {
  margin: 0px 20px;
  margin-bottom: 12px;
  background-color: white;
}
.custom_title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 8px;
  margin-bottom: 10px;
}
.list-title {
  color: #1c1c1c;
  font-size: 3.8vw;
}
.title-more {
  font-weight: bold;
  margin-top: 5px;
}
.list-content {
  font-size: 3.8vw;
  color: #1c1c1c;
  text-align: left;
  white-space: pre-wrap;
}
.custom-box {
  display: flex;
  flex-wrap: wrap;
}

.custom_imgs {
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
}
.content-image {
  --van-grid-item-content-padding: 0;
  display: flex;
  justify-content: flex-start;
  margin: 6px 0;
  flex-wrap: wrap;
}
.img1 {
  /*1张图 */
  width: 66%;
}
.img2 {
  /*2张图*/
  width: 33%;
  margin-right: 10px;
}
.img3 {
  /*3、4、5、6张图*/
  width: 32%;
  margin-right: 10px;
}
.custom_detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 5px;
  border-top: 1px solid #e0e0e0;
}
.detail_left {
  display: flex;
  align-items: center;
}
.detail_right {
  color: #aaa5a5;
}
.van-button--default {
  color: #aaa5a5;
  background: var(--van-button-default-background-color);
  border: var(--van-button-border-width) solid
    var(--van-button-default-border-color);
}
.wish-btn {
  padding: 15px 30px;
  text-align: center;
}
.content-tabs {
  width: 265px;
  height: 34px;
  margin: 12px auto;
  border-radius: 17px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 1px 1px 1px 1px #e0e0e0;
  z-index: 999;
  // position: absolute;
  // top: -25px;
  // left: 0;
  // right: 0;
  // padding-top: 10px;
  .slot-title {
    font-weight: 600;
    font-size: 3.8vw;
    display: inline-block;
    height: 30px;
  }
  .line {
    width: 2px;
    height: 16px;
    background: #dbdbdb;
    position: absolute;
    right: 0;
    top: 10px;
  }
}
</style>
